module.exports = __webpack_public_path__ + "img/Rehabilitation_Nurse.d5d36c14.png";